import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import i18n from '../infrastructure/I18n/i18n';


export const addDays = (date: $TSFixMe, days: $TSFixMe) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() + days);
    return newDate;
};

export const subtractDays = (date: $TSFixMe, days: $TSFixMe) => {
    const newDate = new Date(date);
    newDate.setDate(date.getDate() - days);
    return newDate;
};

export const makeTint = (hexColorCode: string): string => {
    if (!hexColorCode) {
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'null' is not assignable to type 'string'.
        return null;
    }
    // See: https://github.com/edelstone/tints-and-shades
    const factor = 0.9;
    const tint = (v: $TSFixMe) => Math.round(v + (255 - v) * factor - 0.2);
    const colorInt = parseInt(hexColorCode.replace(/^#/, ''), 16);
    const tintedColor = (
        tint((colorInt & 0xff0000) / 0x10000) * 0x10000 +
        tint((colorInt & 0x00ff00) / 0x100) * 0x100 +
        tint(colorInt & 0xff)
    ).toString(16);
    return `#${tintedColor}`;
};

export const dateToNativeDatepickerFormat = (date: Date) => {
    const locale = i18n.language;
    return dayjs(date).locale(locale).format('YYYY-MM-DDTHH:mm');
};

export const getTimezoneOffset = () => {
    let offset = new Date().getTimezoneOffset();
    const sign = offset < 0 ? '+' : '-';
    offset = Math.abs(offset);
    return `${sign}${offset / 60}${offset % 60 !== 0 ? '.' + (offset % 60) : ''}`;
};

export const wait = (ms: $TSFixMe) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
